<template>
  <div :class="['ratings', {'zero-based': zeroBased, stars: stars, numbers: !stars, hovering: !!hovered, 'not-hovering': !hovered}]">
    <label v-for="index in range" :class="{active: (hovered) ? index <= hovered : index <= innerValue, 'read-only': readOnly}" @mouseenter="hovered = index" @mouseleave="hovered = null">
      <input type="radio" :name="name" :value="index" v-model="innerValue" @change="updateValues" :disabled="readOnly">
      <sprite name="iconStarOutline" v-if="stars" class="star-icon star-icon--outline" />
      <sprite name="iconStar" v-if="stars" class="star-icon star-icon--active" />
      <span v-else>{{index}}</span>
    </label>
  </div>
</template>

<script>

  export default {
    name: 'Ratings',
    props: {
      value: {},
      range: {
        type: Array,
        required: true
      },
      name: {
        type: String
      },
      readOnly: {
        type: Boolean,
        default: false
      },
      stars: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        innerValue: this.value,
        zeroBased: this.range[0]===0,
        hovered: null
      }
    },
    methods: {
      updateValues () {
        this.$emit('input', this.innerValue)
      }
    }
  }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

  @import "~globals";

  label {
    position:relative;
    .stars & {
      @include animate-css(fadeInRight, 0, .5s);
      @for $i from 0 through 10 {
        &:nth-child(#{$i}) {
          animation-delay: #{(.1 * $i) - .1}s;
        }
      }
    }
  }

  .ratings {
    &.stars {
      @include checkboxes($fluff: false)
    }
    &.numbers {
      @include checkboxes($fluff: true)
      &.zero-based {
        label {
          &.active {
            &:first-child {
              background-color:$color-gray-darker; border-color:$color-gray-darker;
            }
          }
        }
      }
    }
  }

  .response {
    label {
      &.active.read-only {
        background-color:$color-gray-darkest; border-color:$color-gray-darkest;
      }
    }
  }

  .star-icon {
    @include transition();
    @include size(3rem);
    fill:$color-primary;
    .ratings.hovering &.star-icon--outline {
      opacity:.5;
    }
    .ratings .active & {
      opacity:1;
    }
    &--active {
      opacity:0; position:absolute;
    }
    .ratings.not-hovering label.active &--active {
      opacity:1;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/_global/ratings.vue